import React, { Component } from "react";
import injectSheet from "react-jss";
import Color from "color";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../Theme/Theme";
import * as Actions from "../../Actions/Actions";
import { CSSTransitionGroup } from "react-transition-group"; // ES6
import { Link } from "react-router-dom";
// import ReactGA from 'react-ga'
import Responsive from "react-responsive";
import ShowView from "./Shows/ShowView";
import back from "../../../assets/close.png";
import AddToPlaylist from "./Shows/Playlists";
import styled from "styled-components";
import { isMobile } from "react-device-detect";
// const Desktop = props => <Responsive {...props} minWidth={1300} />
// const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={1299} />
// const Mobile = props => <Responsive {...props} maxWidth={767} />

const Add = styled.div.attrs({
  className: "fas fa-plus"
})`
  color: ${palette.white};
  border-radius: 50%;
  transition: all 0.4s;
  width: 2.5vw;
  height: 2.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5vw;
  border: 1px solid ${palette.white};
  &:hover {
    cursor: pointer;
    border: 1px solid ${palette.teal};
    color: ${palette.teal};
  }
`;

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHeroShown: true
    };
    this.playShow = this.playShow.bind(this);
  }
  render() {
    const { classes } = this.props;
    const { Body } = classes;
    return (
      <div className={Body}>
        {this.props.libraryState.pending && this.props.loggedUserState.logged
          ? this.loading()
          : this.library()}
        <CSSTransitionGroup
          transitionName={{
            enter: classes.enter,
            enterActive: classes.active,
            leave: classes.leave,
            leaveActive: classes.leaveActive
          }}
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {this.state.isHeroShown && this.props.content != null
            ? this.returnHero()
            : null}
        </CSSTransitionGroup>
        {this.props.addToPlaylist ? (
          <div style={{ zIndex: "2" }}>
            <AddToPlaylist />
          </div>
        ) : null}
      </div>
    );
  }

  returnHero() {
    const { classes, content } = this.props;
    return (
      <div
        onClick={() => {
          this.showHero(null);
        }}
        className={classes.hero}
      >
        <div className={classes.textContainer}>
          <div className={classes.infoControlsContainer}>
            <div className={classes.backContainer}>
              <img src={back} className={classes.img} alt="" />
            </div>
            <div className={classes.title}>{content.caption}</div>
            <div className={classes.description}>{content.description}</div>
            {this.returnButtons()}
          </div>
        </div>
        <div className={classes.imgContainer}>
          <img className={classes.heroImg} src={content.heroImageUrl} />
        </div>
      </div>
    );
  }

  returnButtons() {
    const { classes, content, library } = this.props;
    const { id } = content
    if (library.quality !== "None") {
      return (
        <div className={classes.buttonContainer}>
          <div
            onClick={() => {
              this.playShow(false);
            }}
            className={classes.button}
          >
            Play
          </div>
          {content.progress !== 0 ? (
            <div
              onClick={() => {
                this.playShow(true);
              }}
              className={classes.button}
            >
              Resume
            </div>
          ) : null}
          <Add onClick={()=>{this.props.dispatch({type: 'TOGGLE_ADD_TO_PLAYLIST', id})}}/>      
        </div>
      );
    } else {
      return (
        <div className={classes.buttonContainer}>
          <Link
            to="/Home/EditPlan"
            style={{
              width: "100%",
              maxWidth: "100%",
              fontSize: "1.2vw",
              textDecoration: "none"
            }}
            className={classes.button}
          >
            Subscribe to Access this Content
          </Link>
        </div>
      );
    }
  }

  playShow(isResumed) {
    // console.log(this.props.content)
    if (isResumed) {      
      this.props.dispatch(Actions.ChooseShow(this.props.content, this.props.content.rowNum, this.props.history));
    } else {
      let content = JSON.parse(JSON.stringify(this.props.content))
      content.progress = 0
      this.props.dispatch(Actions.ChooseShow(content, this.props.content.rowNum, this.props.history));
    }
    // if (isMobile) {
    //   // this.props.history.push("/Home/Mobile");      
    //   return;
    // }
  }

  showHero(content) {
    this.props.dispatch(Actions.ChooseHero(content));
  }

  loading() {
    const { classes } = this.props;
    return <div className={classes.loading}>Loading Library...</div>;
  }

  library() {
    const { classes } = this.props;
    // console.log('testing')
    return (
      <React.Fragment>
        {this.props.library.view.map((view, index) => {
          return <ShowView index={index} view={view} key={index} />;
        })}
      </React.Fragment>
    );
  }

  componentDidMount() {
    if (this.props.addToPlaylist) {
      this.props.dispatch({ type: "TOGGLE_ADD_TO_PLAYLIST" });
    }
    this.props.dispatch({ type: "RESET_SHOW_COUNT" });
    // console.log(this.props.location.state)
    if (this.props.location.state !== undefined && this.props.location.state.fromShow === true) {
      this.props.dispatch(Actions.getPlaylists(this.props.user.token));
      return
    }
    this.props.dispatch(Actions.getLibrary(this.props.user.token));
    this.props.dispatch(Actions.getPlaylists(this.props.user.token));    
  }
}

const styles = {
  ...flexUtils,
  enter: {
    opacity: "0"
  },
  active: {
    opacity: "1",
    transition: "opacity .3s"
  },
  leave: {
    opacity: "1"
  },
  leaveActive: {
    opacity: "0",
    transition: "opacity .3s"
  },
  heroImg: {
    width: "100vw"
  },
  backContainer: {
    width: "100%",
    marginTop: ".5vh",
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    fontSize: "1.5vw",
    fontWeight: "600",
    "&:hover": {
      cursor: "pointer"
    }
  },

  img: {
    width: "1.5vw",
    marginRight: "1rem",
    marginLeft: "1rem"
  },
  Body: {
    composes: ["$FlexColumn"],
    justifyContent: "center",
    alignItems: "center",
    flex: "1",
    minHeight: "70vh",
    minWidth: "100vw",
    marginTop: "7vh"
  },
  textContainer: {
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "left",
    flexDirection: "column",
    zIndex: "1",
    color: palette.white,
    top: "8.5vh",
    width: "100vw",
    height: "91.5vh"
    // backgroundColor: 'red'
  },
  buttonContainer: {
    marginTop: "3vw",
    // backgroundColor: 'red',
    width: "80%",
    display: "flex",
    alignItems: 'center',
    marginRight: "15%",
    position: 'relative',
    justifyContent: "space-around",
    flexDirection: "row"
  },
  button: {
    borderRadius: "5px",
    transition: "all .4s",
    width: "10vw",
    maxWidth: "10rem",
    maxHeight: "3rem",
    height: "3vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.5vw",
    fontWeight: "600",
    color: palette.white,
    backgroundColor: palette.blue,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: Color(palette.blue)
        .darken(0.3)
        .toString()
    }
  },
  infoControlsContainer: {
    width: "31vw",
    // backgroundColor: 'red',
    height: "27vw",
    maxHeight: "27vw",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "column",
    marginTop: "-8.6vh"
  },
  title: {
    fontSize: "2vw",
    fontWeight: "600",
    width: "90%",
    // backgroundColor: 'blue',
    paddingTop: "2.5vw"
  },
  description: {
    width: "90%",
    fontSize: "1.2vw"
    // paddingTop: '2vw'
  },
  imgContainer: {
    // marginTop: '-8.5vh'
  },
  hero: {
    // animation: 'fadein .7s',
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "2",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: Color("rgba(0,0,0)")
      .alpha(0.7)
      .toString()
  },
  loading: {
    fontSize: "3vw",
    color: palette.white
  }
};

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    libraryState: state.mainState.libraryState,
    library: state.mainState.library,
    content: state.mainState.content,
    loggedUserState: state.mainState.loggedUserState,
    addToPlaylist: state.mainState.addToPlaylist
  };
};

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(Home)));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Home.jsx